import React, { useEffect, useRef, useState } from 'react'
import {
  Layout,
  message,
  Checkbox,
  Select,
  Modal,
  Col,
  Row,
  ConfigProvider,
  Pagination,
  Tabs,
  Button,
  Input,
  Tooltip,
  Popconfirm,
  Radio,
} from 'antd'
import { sendHttpPostRequest } from '../../api/http-request'
import courseStyles from './course.module.less'
import './course.module.css'
import zhCN from 'antd/lib/locale/zh_CN'
import * as constants from '../../constants/constants'
import { checkUserLogin } from '../common/user-center/user-info'
import courseMainStyles from './course-main.module.less'
import {
  GlobalOutlined,
  UserOutlined,
  SearchOutlined,
  StarOutlined,
  FileAddOutlined,
  BarsOutlined,
  ReadOutlined,
  CodeOutlined,
  HomeOutlined,
  TeamOutlined,
  PlusOutlined
} from '@ant-design/icons'

import SlideIcon from '../../component/SvgIcons/myicons'

import emptyCourse from '../../static/image/empty/queshengye-kecheng.png'
import { getCollegeId } from '../../component/modal/teacher-authenticate/teacher-authenticate'

import Feedback from '../common/feedback-help/feedback'
import Cookies from 'js-cookie'
import Draggable from 'react-draggable'

import slidesStyles from './slides/course-main-teacher-slides.module.less'

import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '../../constants/constants'

import Icon from '@ant-design/icons'
import  {ReactComponent as mydeleteSvg }   from '../../static/image/course/mydelete.svg'
const mydeleteIcon = (props:any) => (<Icon component={mydeleteSvg} {...props} />)

const { TabPane } = Tabs
const { Option } = Select

interface Course {
  course_id: number
  name: string
  cover: string
}

export interface Props {}
export const Course: React.FC<Props> = (props) => {
  const [courseResult, setCourseResult] = useState(null as any)
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数

  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(9) // 记录当前每页展示数量
  const queryContent = useRef('') // 记录搜索串

  const [isLogin, setIsLogin] = useState(false) //是否登录
  const [collegeId, setCollegeId] = useState(null as any) // 院校ID
  const [collegeName, setCollegeName] = useState(null as any) // 院校名称
  const [collegeInfo, setCollegeInfo] = useState(null as any) //查询当前用户的机构信息,is_college_teacher weitrue表示是教师，
  const [myCollegeList, setMyCollegeList] = useState(null as any) //我的机构列表

  const [systemPublisedCoourseList, setSystemPublisedCoourseList] = useState(
    null as any
  ) //平台已上线课程列表，供未登录和未加机构用户查看

  const [role, setRole] = useState('教师')

  const [wrongHidden, setWrongHidden] = useState(true)
  const [inviteNumber, setInviteNumber] = useState(null as any)
  const [joinSuccessVisible, setJoinSuccessVisible] = useState(false)

  const [value, setValue] = React.useState(1)

  const [courseList, setCourseList] = useState(null as any)

  const courseSource = React.useRef(1)

  const [copyCourseId, setCopyCourseId] = React.useState(null as any) //要复制的课程ID
  const [copyMenu, setCopyMenu] = React.useState(1)
  const [copyLecture, setCopyLecture] = React.useState(1)
  const [copyCase, setCopyCase] = React.useState(1)

  const [collegeManagerPhone, setCollegeManagerPhone] = useState("")

  const [newCourseName, setNewCourseName] = React.useState('') // 新创建课程的名称

  const [newCourseType, setNewCourseType] = React.useState(1) // create course type 1 = 复制创建  2-原创创建

  const [isModalVisible, setIsModalVisible] = useState(false)
  const draggleRef = useRef<HTMLDivElement | null>(null)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }

  /** 未加机构弹窗变量 */
  const [isNoCollegeModalVisible, setIsNoCollegeModalVisible] = useState(false)
  const draggleNoCollegeRef = useRef<HTMLDivElement | null>(null)
  const [noCollegeBounds, setNoCollegeBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [noCollegeDisabled, setNoCollegeDisabled] = useState(true)

  const onNoCollegeStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleNoCollegeRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setNoCollegeBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }



  useEffect(() => {
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response.is_ok == true) {
          setIsLogin(true)
          //setCourseLoaded(false)
          if (response?.college_id !== 0) {
            //已加入机构
            let _collegeId = response.college_info.college_id
            setCollegeId(_collegeId)
            setCollegeInfo(response.college_info)
            setMyCollegeList(response.college_list)
            /** 设置机构、当前人员教师和学生身份 */
            sendHttpPostRequest(
              'course/api/user_query_college_course_list',
              {
                sessionid: Cookies.get('sessionid'),
                sid: Cookies.get('sessionid'),
                college_id: _collegeId,
                source: 1,
                page: page.current,
                pagesize: pageSize.current,
                query: queryContent.current,
              },
              (response: any) => {
                message.destroy()
                //setCourseLoaded(true)
                if (response.is_ok == true) {
                  if (response.query_list) {
                    setCourseResult(response.query_list)
                    setResultSum(response.total_sum)
                  }
                }
              }
            )
          } else {
            //未加入机构
            setCollegeId(0)
            let url = 'account/api/user_get_college_manager_idens'
            sendHttpPostRequest(url, {}, (res) => {
             setCollegeManagerPhone(res.data.manager_idens)
            })
            querySystemPublishedCourseList()
          }
        } else {
          //用户未登录
          querySystemPublishedCourseList()
        }
      }
    )
  }, [])

  const querySystemPublishedCourseList = () => {
    sendHttpPostRequest(
      'course/api/user_query_system_published_course_list',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        page: page.current,
        pagesize: pageSize.current,
        query: queryContent.current,
      },
      (response: any) => {
        message.destroy()
        //setCourseLoaded(true)
        if (response.is_ok == true) {
          if (response.query_list) {
            setSystemPublisedCoourseList(response.query_list)
            setResultSum(response.total_sum)
          }
        }
      }
    )
  }


    /**
   * 创建课程回调
   * @param response
   */
    const setCreateCourseCallback = (response: any) => {
      message.destroy()
      if (response.code == -100) {
        // 没登录
        window.location.href = '/login?next=course'
      } else if (response.code == -501) {
        // 没权限
        window.location.href = '/login?next=course'
      } else if (response.is_ok == true) {
        if (response.course_id) {
          setIsModalVisible(false)
          window.open(`/course-main-teacher?course_id=${response.course_id}&tabKey=1&course_edit=1`)
        } else {
          message.error(response.message)
        }
      }else{
        message.error(response.message)
      }
    }
  
    /**
     * 点击创建课程
     */
    const createCourse = () => {
      let _collegeId = collegeId
      if (_collegeId == 0) {
        _collegeId = getCollegeId()
      }
      sendHttpPostRequest(
        'course/api/user_create_course',
        {
          sessionid: Cookies.get('sessionid'),
          college_id: _collegeId,
          course_name: newCourseName
          
        },
        setCreateCourseCallback
      )
    }


  const handleOk = () => {

    if (newCourseType == 1){ //复制创建课程
      if (copyCourseId) {
        //勾选了复制的课程
        setIsModalVisible(false)

        let _collegeId = collegeId
        if (_collegeId == 0) {
          _collegeId = getCollegeId()
        }

        sendHttpPostRequest(
          'course/api/user_create_course',
          {
            course_id: copyCourseId,

            copy_menu: copyMenu,
            copy_lecture: copyLecture,
            copy_case: copyCase,

            college_id: _collegeId,

            sessionid: Cookies.get('sessionid'),
          },
          setCreateCourseCallback
        )

        setValue(1) // 默认改为平台
      } else {
        message.error('请选择一门复用课程，或者直接点击新建课程~')
      }
    }else { // 原创创建课程
      createCourse()
    }
  }

  const handleCancel = () => {
    setIsModalVisible(false)
    // 
    setValue(1) // 默认改为平台
  }



  const onChangeMenu = (e) => {
    setCopyMenu(e.target.checked ? 1 : 0)
  }

  const onChangeLecture = (e) => {
    setCopyLecture(e.target.checked ? 1 : 0)
  }

  const onChangeCase = (e) => {
    setCopyCase(e.target.checked ? 1 : 0)
  }

  const handleSelectChange = (e) => {
    console.log('选择的课程是：')
    console.log(e)
    setCopyCourseId(e)
  }

  const onRadioChange = (e) => {
    let _collegeId = collegeId
    if (_collegeId == 0) {
      _collegeId = getCollegeId()
    }
    setValue(e.target.value)
    sendHttpPostRequest(
      'course/api/user_query_college_course_list',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        college_id: _collegeId,
        source: e.target.value,
        page: page.current,
        pagesize: 1000,
        query: '',
      },
      (response: any) => {
        message.destroy()
        if (response.is_ok == true) {
          if (response.query_list) {
            if (e.target.value == 1) {
              setCourseList(
                response.query_list.filter(
                  (item) => item.ispay == '已购买' && item.isoutdate == 0
                )
              )
            } else {
              setCourseList(response.query_list.filter((item) => item.src_valid == 1))
            }
            setResultSum(response.total_sum)
          }
        }
      }
    )
  }

  const onCourseCardClick = (course_id, ispay) => {
    message.destroy()
    window.open(`/course-main?course_id=${course_id}`)
  }
 /* 用户当前没有机构信息或 没有登录 点击了  平台课程卡片*/

  const onCourseCardWithoutCollegeClick = (course_id, ispay) => {
    if (!checkUserLogin()) { // 如果没登录就提示登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click() 
    }else { //提示加入机构
      //message.info("您当前尚未加入机构，请进入个人中心输入院校码加入机构~")
      setIsNoCollegeModalVisible(true)
    }
  }


  const onCollegeCourseCardClick = (course_id) => {
    message.destroy()
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      let role = 'student'
      if (collegeInfo?.is_college_teacher == 1) {
        role = 'teacher'
        window.open(`/course-main-${role}?course_id=${course_id}&tabKey=1`)
      } else {
        window.open(`/course-main-${role}?course_id=${course_id}`)
      }
    }
  }

  const onCourseTabChange = (key: string) => {
    if ('3' == key) {
      // 我的
      if (!checkUserLogin()) {
        sessionStorage.setItem("previousurl",window.location.href )
        document.getElementById('show-login-modal')!.click()
        setCourseResult([])
      }
      courseSource.current = 3
      page.current = 1
      queryCollegeCourse()
    } else if ('2' == key) {
      courseSource.current = 2
      // 院校
      if (!checkUserLogin()) {
        sessionStorage.setItem("previousurl",window.location.href )
        document.getElementById('show-login-modal')!.click()
        setCourseResult([])
      }
      if (collegeId == null || collegeId == 0) {
        setCourseResult([])
      } else {
        //setCourseResult([])
        page.current = 1
        queryCollegeCourse()
      }
    } else {
      courseSource.current = 1
      page.current = 1
      queryCollegeCourse()
    }
  }

  // 查询院校课程
  const queryCollegeCourse = () => {
    let _collegeId = collegeId
    if (_collegeId == 0) {
      _collegeId = getCollegeId()
    }
    sendHttpPostRequest(
      'course/api/user_query_college_course_list',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        college_id: _collegeId,
        source: courseSource.current == 0 ? null : courseSource.current,
        page: page.current,
        pagesize: pageSize.current,
        query: queryContent.current,
      },
      (response: any) => {
        message.destroy()
        //setCourseLoaded(true)
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          setCourseResult([])
        } else if (response.code == -501) {
          // 没权限
        } else if (response.is_ok == true) {
          if (response.query_list) {
            setCourseResult(response.query_list)
            setResultSum(response.total_sum)
          }
        }
      }
    )
  }

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryCollegeCourse()
  }

  /**
   * 点击了创建课程按钮
   */
  const onCreateCourseClick = () => {
    message.destroy()
    if (!checkUserLogin()) {
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else {
      let _collegeId = collegeId
      if (_collegeId == 0) {
        _collegeId = getCollegeId()
      }
      sendHttpPostRequest(
        'course/api/user_query_college_course_list',
        {
          sessionid: Cookies.get('sessionid'),
          sid: Cookies.get('sessionid'),
          college_id: _collegeId,
          source: value,
          page: page.current,
          pagesize: pageSize.current,
          query: queryContent.current,
        },
        (response: any) => {
          message.destroy()
          //setCourseLoaded(true)
          if (response.is_ok == true) {
            if (response.query_list) {
                if(value == 1){ 
                  setCourseList(response.query_list.filter((item) => item.ispay == '已购买' && item.isoutdate == 0))
                }else {
                  setCourseList(response.query_list.filter((item) => item.src_valid == 1))
                }
            }
          }
        }
      )

      setIsModalVisible(true)
      // }
    }
  }

  //点击了搜索按钮
  const onSearchBtn = (event: any) => {
    page.current = 1
    queryContent.current = event.target.value
    if (collegeId > 0) {
      queryCollegeCourse()
    } else {
      querySystemPublishedCourseList()
    }
  }


  /**
   * 删除课程回调
   */
  const setDeleteCourseCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
        sessionStorage.setItem("previousurl",window.location.href )
        document.getElementById('show-login-modal')!.click()
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/login?next=course'
    } else if (response.is_ok == true) {
      message.success('课程删除成功~')
    } else {
      message.error('课程删除失败~')
    }
  }

  /**
   * 点击删除课程
   */
  const deleteCourse = (courseId: string | number) => {
    sendHttpPostRequest(
      'course/api/user_delete_course',
      {
        sessionid: Cookies.get('sessionid'),
        course_id: courseId,
      },
      setDeleteCourseCallback
    )
    queryCollegeCourse()
  }

  const onInviteChange = (e: any) => {
    setInviteNumber(e.target.value)

  }

  // 用户加入院校
  const userJoinCollegeCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 未登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
    } else if (response.is_ok == true) {
      setCollegeId(response.college_id)
      setCollegeName(response.college_name)
      if (response.college_role == 2) {
        setWrongHidden(true)
        setRole('教师')
        setJoinSuccessVisible(true)
        setTimeout(function () {
          setJoinSuccessVisible(false)
          queryCollegeCourse()
        }, 2000)
      } else if (response.college_role == 1) {
        setWrongHidden(true)
        setRole('学生')
        setJoinSuccessVisible(true)
        setTimeout(function () {
          setJoinSuccessVisible(false)
          queryCollegeCourse()
        }, 2000)
      } else {
        setWrongHidden(false)
      }

    } else if (response.code == -9) {
      console.log(response.college_id)
      setCollegeId(response.college_id)
      queryCollegeCourse()
    } else {
      message.error(response.message)
    }
  }

  // 用户加入院校
  const userJoinCollege = () => {
    sendHttpPostRequest(
      'college/api/user_join_college_by_code',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        college_code: inviteNumber,
      },
      userJoinCollegeCallback
    )
  }



  const statusMyColor = (courseStatusMy: any) => {
    if (courseStatusMy == '进行中') {
      return '#0ea5e9'
    } else if (courseStatusMy == '未发布') {
      return '#6b7280'
    } else if (courseStatusMy == '未开课') {
      return '#ff9f43'
    } else if (courseStatusMy == '已结课') {
      return '#10b981'
    } else {
      return '#6C757DE6'
    }
  }

  return (
    <Layout style={{ minHeight: 750, backgroundColor: '#f9f9f9' }}>
      <div className={courseStyles.maincontent}>
        <div className={courseStyles.courseList}>
          <Row gutter={[16, 16]} style={{ marginBottom: 32, paddingRight:24 }}>
            <Col span={24}>
              <Row wrap={false} align={"middle"}>
                <Col flex="auto">
                  <Input
                    onPressEnter={onSearchBtn}
                    placeholder="请输入课程名称或简介..."
                    className={courseStyles.searchInput}
                    suffix={<SearchOutlined style={{ color: '#666666' }} />}
                  />
                </Col>

                {collegeInfo?.is_college_teacher == 1 &&  <Col flex={"160px"} style={{textAlign:'right'}}>

                  <div >
                    <span
                      onClick={onCreateCourseClick}
                      className={courseStyles.createBtn}
                     
                    >
                     <PlusOutlined /> 创建课程
                    </span>
                  </div>
                
                </Col>
                }

              </Row>
            </Col>
          </Row>

          <Tabs
            defaultActiveKey="1"
            size="small"
            onChange={onCourseTabChange}
            style={{ paddingRight:24 }}
          >
            <TabPane tab={<div><GlobalOutlined /> 平台</div>} key="1">
              <div
                className={courseStyles.cardListWarpper}
              >
                {collegeId > 0 ? (
                  <Row gutter={[36, 36]} wrap={true} justify="start">
                    {courseResult?.map((course) => {
                      return (
                        <Col key={course.course_id} span={8} >
                          <div
                            className={courseStyles.courseCard}

                            onClick={onCourseCardClick.bind(
                              this,
                              course.course_id,
                              course.ispay
                            )}
                          >

                            <div style={{width:'100%', position:'relative', overflow:'hidden'}} className={courseStyles.cardCoverWrapper}>
                                {course?.ispay == '未购买' && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: 15,
                                    right: -30,
                                    transform:'rotate(45deg)',
                                    fontSize: 12,
                                    paddingLeft: 35,
                                    paddingRight: 35,
                                    color: '#E8E8E8',
                                    whiteSpace:'nowrap',
                                    backgroundColor: 'rgba(0,0,0,.8)',
                                  }}
                                >
                                  未购买
                                </div>
                              )}
                              {course?.ispay == '已购买' &&
                                course?.isoutdate == 1 && (
                                  <div
                                    style={{
                                      position: 'absolute',
                                      top: 15,
                                      right: -30,
                                      transform:'rotate(45deg)',
                                      fontSize: 12,
                                      backgroundColor:'rgba(255, 75, 80, 0.8)',
                                      //width: 74,
                                      paddingLeft: 35,
                                      paddingRight: 35,
                                      color: '#E8E8E8',
                                      whiteSpace:'nowrap'
                                    }}
                                  >
                                    已过期
                                  </div>
                                )}

                              <img
                                alt=""
                                src={
                                  course.cover?.startsWith('http')
                                    ? course.cover
                                    : constants.BACKEND_URL + course.cover
                                }
                                height={"100%"}
                                width={"100%"}
                                style={{
                                  borderTopRightRadius: 12,
                                  borderTopLeftRadius: 12,
                                }}
                              />
                            </div>

                            <div className={courseStyles.cardContentDiv}>
                              <Row
                                align="middle"
                                justify="start"
                                gutter={[12, 12]}
                              >
                                <Col
                                  span={24}
                                  className={courseStyles.courseTitle}
                                  style={{height:25}}
                                >
                                  {course.name}
                                </Col>
                              </Row>
                            
                              <div  
                                title={course?.description} 
                                className={courseStyles.courseDescription}
                              
                                >
                                {course?.description}
                              </div>

                              <div style={{height:45, textAlign:'left', lineHeight:'45px'}}>
                                {course?.ispay == '已购买' && <span style={{fontSize:14, color:course?.isoutdate == 1? '#FF4B50':'#666'}}>{course?.apply_end_time}{course?.isoutdate == 1?'已到期': '到期'}</span>}
                              </div>

                              <Row justify="start" style={{ marginTop: 5 }}> {/**底部统计数据 */}
                                <Col span={6}  className={courseStyles.courseCountSpanCol}  >  {/** 平台课知识点数量 */}
                                  <Tooltip placement="top" title={'知识点'}><ReadOutlined /> {course?.knowcell_count} 知识点</Tooltip> 
                                </Col>

                                <Col span={6} className={courseStyles.courseCountSpanCol} >  {/**平台课课件数量 */}
                                  <Tooltip placement="top" title={'课件'}> <SlideIcon /> {course?.slide_count} 课件</Tooltip> 
                                </Col>

                                <Col span={6} className={courseStyles.courseCountSpanCol} >  {/**平台课 实验数量 */}
                                  <Tooltip placement="top" title={'实验'}> <CodeOutlined /> {course?.case_count} 实验</Tooltip> 
                                </Col>

                                <Col span={6} className={courseStyles.courseCountSpanCol} >  {/* 平台课习题数量 */}
                                  <Tooltip placement="top" title={'习题'}>  <BarsOutlined /> {course?.exercise_count} 习题</Tooltip> 
                                </Col>
                              </Row>
                            </div>


                          </div>



                        </Col>
                      )
                    })}
                  </Row>
                ) : (
                  <Row gutter={[36, 36]} wrap={true} justify="start">
                    {systemPublisedCoourseList?.map((course) => {
                      return (
                        <Col key={course.course_id }  span={8} >
                          <div
                            className={courseStyles.courseCard}

                            onClick={onCourseCardWithoutCollegeClick.bind(
                              this,
                              course.course_id,
                              course.ispay
                            )}

                          >
                        <div className={courseStyles.cardCoverWrapper}> 
                            <img
                                alt=""
                                src={
                                  course.cover?.startsWith('http')
                                    ? course.cover
                                    : constants.BACKEND_URL + course.cover
                                }
                                height={"100%"}
                                width={"100%"}
                                style={{
                                  borderTopRightRadius: 12,
                                  borderTopLeftRadius: 12,
                                }}
                              />

                            </div>


                          <div className={courseStyles.cardContentDiv}> 
                            <Row
                              align="middle"
                              justify="start"
                              gutter={[12, 12]}
                            >
                              <Col
                                span={24}
                                className={courseStyles.courseTitle}
                                style={{height:25}}
                              >
                                {course.name}
                              </Col>
                            </Row>



                            <div title={course?.description} className={courseStyles.courseDescription} >
                              {course?.description}
                            </div>

                            <div style={{height:45}}></div>


                            <Row justify="start" style={{ marginTop: 5 }}> {/**底部统计数据 */}
                                <Col span={6}  className={courseStyles.courseCountSpanCol}  >  {/** 平台课知识点数量 */}
                                  <Tooltip placement="top" title={'知识点'}><ReadOutlined /> {course?.knowcell_count} 知识点</Tooltip> 
                                </Col>

                                <Col span={6} className={courseStyles.courseCountSpanCol} >  {/**平台课课件数量 */}
                                  <Tooltip placement="top" title={'课件'}> <SlideIcon /> {course?.slide_count} 课件</Tooltip> 
                                </Col>

                                <Col span={6} className={courseStyles.courseCountSpanCol} >  {/**平台课 实验数量 */}
                                  <Tooltip placement="top" title={'实验'}> <CodeOutlined /> {course?.case_count} 实验</Tooltip> 
                                </Col>

                                <Col span={6} className={courseStyles.courseCountSpanCol} >  {/* 平台课习题数量 */}
                                  <Tooltip placement="top" title={'习题'}>  <BarsOutlined /> {course?.exercise_count} 习题</Tooltip> 
                                </Col>
                              </Row>
                            </div>

                          </div>
                        </Col>
                      )
                    })}
                  </Row>
                )}
              </div>
              <ConfigProvider locale={zhCN}>
                <div
                  style={{ marginBottom: 30, paddingTop: 30 }}
                  className={'css.pagination'}
                >
                  <Pagination
                    defaultCurrent={1}
                    total={resultSum}
                    defaultPageSize={9}
                    hideOnSinglePage={true}
                    onChange={onPageChange}
                    current={page.current}
                    showQuickJumper={true}
                    showSizeChanger={false}
                  />
                </div>
              </ConfigProvider>
            </TabPane>
            {isLogin == true && (
              <TabPane tab={<div><HomeOutlined /> 院校</div>} key="2">
                {collegeId == 0 && (
                  <div className={courseStyles.cardListWarpper}>
                    <div 
                    style={{ marginTop: 60 }}>
                      <div style={{ color: '#666' }}>请输入所在院校院校码</div>
                      <div
                        style={{ color: '#666', fontSize: 12, marginTop: 10 }}
                      >
                        获取院校码请联系{collegeManagerPhone}
                      </div>
                      <Input
                        style={{
                          width: 256,
                          marginTop: 30,
                          borderRadius: 20,
                          borderColor: '#707070',
                        }}
                        onChange={onInviteChange}
                      ></Input>
                      <div
                        style={{
                          textAlign: 'center',
                          marginTop: 5,
                          color: '#ff4b50',
                        }}
                        hidden={wrongHidden}
                      >
                        院校码无效，请输入正确的院校码
                      </div>
                      <div style={{ marginTop: 50 }}>
                        <Button
                          type="primary"
                          style={{ borderRadius: 3, width: 74 }}
                          onClick={userJoinCollege}
                        >
                          确认
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                {courseResult?.length != 0 && (
                  <div
                    className={courseStyles.cardListWarpper}
                  >
                    <Row gutter={[36, 36]} wrap={true} justify="start">
                      {courseResult?.map((course) => {
                        return (
                          <Col key={course.course_id}  span={8}  >
                            <div
                              className={courseStyles.courseCard}

                              onClick={onCollegeCourseCardClick.bind(
                                this,
                                course.id
                              )}      
                            >

                          <div className={courseStyles.cardCoverWrapper}>
                              <img
                                    src={
                                      course.cover?.startsWith('http')
                                        ? course.cover
                                        : constants.BACKEND_URL + course.cover
                                    }
                                    height={"100%"}
                                    width={"100%"}
                                    style={{
                                      borderTopRightRadius: 12,
                                      borderTopLeftRadius: 12,
                                    }}
                                  />


                            </div>

                            <div  className={courseStyles.cardContentDiv}> 
                              {collegeInfo?.is_college_teacher == 1 && (
                                <Row
                                  align="middle"
                                  justify="start"
                                  gutter={[12, 12]}
                                >
                                  <Col
                                    span={24}
                                    className={courseStyles.courseTitle}
                                  >
                                    {course.name}
                                  </Col>
                                </Row>
                              )}

                              {collegeInfo?.is_college_teacher == 0 && ( //学生才显示课程状态
                                <Row
                                  align="middle"
                                  justify="start"
                                  gutter={[12, 12]}
                                  wrap={false}
                                >
                                  <Col
                                    span={24}
                                    className={courseStyles.courseTitle}
                                  >
                                    {course.name}
                                  </Col>
                                </Row>
                              )}

                              
                              <div style={{height: 110}}>
                                <div style={{textAlign:'left',  fontSize: 14, color: '#666', margin:'10px 0'}}>
                                  <div style={{margin:'0 0 8px'}}> 课程开始: {course.start_time}</div>
                                  <div> 课程结束: {course.end_time}</div>
                                  
                                </div>


                                <Row
                                  style={{
                                    height: 20,
                                    fontSize: 14,
                                    color: '#666',
                                    marginTop: 5,
                                  }}
                                >
                                  {course?.code !== '' && (
                                    <Col
                                      span={11}
                                      title={course?.code}
                                      style={{
                                        textAlign: 'left',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      课号：{course?.code}
                                    </Col>
                                  )}
                                  {course?.code !== '' &&
                                    course?.class !== '' && (
                                      <Col span={2}>
                                        <span
                                          style={{
                                            display: 'block',
                                            float: 'left',
                                            width: 1,
                                            height: 10,
                                            backgroundColor: '#ccc',
                                            margin: '4px 6px 0',
                                          }}
                                        ></span>
                                      </Col>
                                    )}
                                  {course?.class !== '' && (
                                    <Col
                                      span={11}
                                      title={course?.class}
                                      style={{
                                        textAlign: 'left',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      班级：{course?.class}
                                    </Col>
                                  )}
                                </Row>
                              </div>

                                <Row justify="start" style={{ marginTop: 5 }}>
                                  <Col
                                    span={18}
                                    style={{ textAlign: 'left', color: '#666',whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                  >
                         

                                      { course?.teacher_avatar &&  <span> <img
                                          className={GlobalCss.avatar}
                                          style={{height:32, width:32}}
                                          src={BACKEND_API_URL + course?.teacher_avatar}
                                          alt=""
                                      /> </span>}

                          
                                     <span style={{marginLeft:5, color:'#303133'}}>{course?.teacher_real_name == ''
                                    ? course?.teacher_name
                                    : course?.teacher_real_name} </span>


                                  </Col>

                                  <Col
                                    span={6}
                                    style={{
                                      textAlign: 'right',
                                    }}
                                    className={courseStyles.courseCountSpanCol}
                                  >
                                    <TeamOutlined /> {course.user_count} 人学习
                                  </Col>

                                </Row>
                              
                              </div>
                            </div>
                          </Col>
                        )
                      })}
                    </Row>
                  </div>
                )}

                {collegeId > 0 && courseResult?.length == 0 && (
                  <div 
                  style={{ paddingTop: 140 }}>
                    <img src={emptyCourse} height={150} />
                    <div style={{ color: '#999999' }}>
                      学院老师还未创建课程哦！
                    </div>
                  </div>
                )}

                <ConfigProvider locale={zhCN}>
                  <div
                    style={{ marginBottom: 30, paddingTop: 30 }}
                    className={'css.pagination'}
                  >
                    <Pagination
                      defaultCurrent={1}
                      total={resultSum}
                      defaultPageSize={9}
                      hideOnSinglePage={true}
                      onChange={onPageChange}
                      current={page.current}
                      //showQuickJumper={true}
                      pageSizeOptions={['3', '20', '30', '50', '100']}
                    />
                  </div>
                </ConfigProvider>
              </TabPane>
            )}

            {isLogin == true && collegeId > 0 && (
              <TabPane tab={<div> <UserOutlined />  我的</div>} key="3">
                <div
                  className={courseStyles.cardListWarpper}
                >
                  <Row gutter={[36, 36]} wrap={true} justify="start">
                    {courseResult?.map((course) => {
                      return (
                        <Col key={course.course_id} span={8} >
                          <div
                            className={courseStyles.courseCard}

                            onClick={onCollegeCourseCardClick.bind(
                              this,
                              course.id
                            )}
                          >


                          <div className={courseStyles.cardCoverWrapper}>

                                {collegeInfo?.is_college_teacher == 1 &&
                                  course?.course_status !== '未发布' && (
                                    <>
                                      {course.visible == 1 && (
                                        <div
                            

                                          className={courseStyles.pulicStatusLabel}
                                        >
                                          公开
                                        </div>
                                      )}
                                    </>
                                  )}


                                { course?.course_status != '--' &&  <div

                                className={courseStyles.courseStatusLabel}
                                style={{

                                  position:'absolute',
                                  left:15,
                                  top:15,

                                  borderRadius:999,

                                  backgroundColor: statusMyColor(
                                    course?.course_status
                                  ),
                                }}
                                >
                                {course?.course_status}
                                </div>
                                }

                                <img
                                  alt=""
                                  src={
                                    course.cover?.startsWith('http')
                                      ? course.cover
                                      : constants.BACKEND_URL + course.cover
                                  }
                                  height={"100%"}
                                  width={"100%"}
                                  style={{
                                    borderTopRightRadius: 12,
                                    borderTopLeftRadius: 12,
                                  }}
                                />

  

                              </div>


                            <div className={courseStyles.cardContentDiv}>
                              <Row
                                align="middle"
                                justify="space-between"
                                gutter={[12, 12]}
                              >
                                <Col
                                  flex={'auto'}
                                  className={courseStyles.courseTitle}
                                >
                                  {course.name}
                                </Col>
                              </Row>

                              <div style={{height: 110}}>
                                <div style={{ textAlign:'left', fontSize: 14, color: '#666',margin:'10px 0' }}>
                                    
                                    <div style={{margin:'0 0 8px'}}> 课程开始: {course.start_time}</div>
                                    <div> 课程结束: {course.end_time}</div>
                                </div>

                                <Row
                                  style={{
                                    height: 20,
                                    fontSize: 14,
                                    color: '#666',
                                    marginTop: 5,
                                  }}
                                >
                                  {course?.code !== '' && (
                                    <Col
                                      span={11}
                                      title={course?.code}
                                      style={{
                                        textAlign: 'left',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      课号：{course?.code}
                                    </Col>
                                  )}
                                  {course?.code !== '' && course?.class !== '' && (
                                    <Col span={2}>
                                      <span
                                        style={{
                                          display: 'block',
                                          float: 'left',
                                          width: 1,
                                          height: 10,
                                          backgroundColor: '#ccc',
                                          margin: '4px 6px 0',
                                        }}
                                      ></span>
                                    </Col>
                                  )}
                                  {course?.class !== '' && (
                                    <Col
                                      span={11}
                                      title={course?.class}
                                      style={{
                                        textAlign: 'left',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    >
                                      班级：{course?.class}
                                    </Col>
                                  )}
                                </Row>

                              </div>

                              <Row justify="start" style={{ marginTop: 5 }} wrap={false} align={"middle"}>
                                <Col
                                  span={18}
                                  style={{ textAlign: 'left', color: '#666' , whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                                >
                                  { false && collegeInfo?.is_college_teacher == 1 && ( //机构教师才显示原创与否的标签
                                    <>
                                      <span
                                        style={{
                                          color: '#07c160',
                                          float: 'left',
                                        }}
                                      >
                                        {course.label}
                                      </span>
                                      {course.label !== '' && (
                                        <span
                                          style={{
                                            display: 'block',
                                            float: 'left',
                                            width: 1,
                                            height: 10,
                                            backgroundColor: '#ccc',
                                            margin: '6px 5px 0',
                                          }}
                                        ></span>
                                      )}
                                    </>
                                  )}


                              
                            { course?.teacher_avatar &&  <span> <img
                                className={GlobalCss.avatar}
                                style={{height:32, width:32}}
                                src={BACKEND_API_URL + course?.teacher_avatar}
                                alt=""
                            /> </span>}
                              <span style={{marginLeft:5,color:'#303133'}}>{course?.teacher_real_name == ''
                                    ? course?.teacher_name
                                    : course?.teacher_real_name} </span>
                                </Col>

                                <Col
                                  span={6}
                                  style={{textAlign: 'right' }}
                                  className={courseStyles.courseCountSpanCol}
                                >
                                

                                  {(collegeInfo?.is_college_teacher == 1 &&
                                  course.label == '原创')  ?  (
                                    <div
                                      //className={courseStyles.myCardAcitionDiv}
                                    >

                                      <Popconfirm
                                        placement="top"
                                        title={'您确定删除此课程吗？'}
                                        onCancel={(e: any) => {e.stopPropagation()}}
                                        onConfirm={(e: any) => {
                                          e.stopPropagation()
                                          deleteCourse(course.id)
                                        }}
                                        okText="确认"
                                        cancelText="取消"
                                      >
                                        <span title="删除"  
                                         onClick={(e: any) => {e.stopPropagation()}} 
                                         className={slidesStyles.deleteIconWrapper} ><Icon component={mydeleteIcon}/></span> 
                                      </Popconfirm>

                                    </div>
                                  ) :
                                  <div>
                                  <TeamOutlined /> {course.user_count} 人学习
                              </div>}

                                  
                                </Col>
                              </Row>

                            </div>
                          </div>
                        </Col>
                      )
                    })}
                  </Row>

                  <ConfigProvider locale={zhCN}>
                    <div
                      style={{ marginBottom: 30, paddingTop: 30 }}
                      className={'css.pagination'}
                    >
                      <Pagination
                        defaultCurrent={1}
                        total={resultSum}
                        defaultPageSize={9}
                        hideOnSinglePage={true}
                        onChange={onPageChange}
                        current={page.current}
                        showQuickJumper={true}
                        pageSizeOptions={['3', '20', '30', '50', '100']}
                      />
                    </div>
                  </ConfigProvider>

                  {courseResult?.length == 0 &&
                    collegeInfo?.is_college_teacher == 1 && (
                      <div style={{paddingTop:60}}>
                        <img src={emptyCourse} height={150} />
                        <div style={{ color: '#999999' }}>
                          您还没有创建课程哟~
                        </div>
                        <Button
                          size="small"
                          style={{
                            border: '1px solid #07c176',
                            color: '#07c176',
                            marginTop: 10,
                            borderRadius: 3,
                            textShadow:'none',
                            boxShadow:'none'
                          }}
                          type="default"
                          onClick={onCreateCourseClick}
                        >
                          {' '}
                          立即创建
                        </Button>
                      </div>
                    )}

                  {courseResult?.length == 0 &&
                    collegeInfo?.is_college_teacher == 0 && (
                      <div style={{paddingTop:60}}>
                        <img src={emptyCourse} height={150} />
                        <div style={{ color: '#999999' }}>
                          你还未加入课程哦~
                        </div>
                      </div>
                    )}
                </div>
              </TabPane>
            )}
          </Tabs>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move' }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                创建课程
              </div>
            }
            width={600}
            closable={true}
            open={isModalVisible}
            className={courseStyles.modal}
            onCancel={handleCancel}
            onOk={handleOk}
            footer={
              <div>
                <Button
                  className={courseStyles.stepsBtn}
                  style={{ marginRight: 20 }}
                  type="default"
                  onClick={handleCancel}
                >
                  取消
                </Button>
                <Button
                  className={courseStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={handleOk}
                >
                  确认
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div
              style={{
                float: 'left',
                width: 260,
                height: 260,
                borderRadius: 3,
                border: newCourseType == 1 ? '1px solid #07c160': '1px dashed #d9d9d9',
                marginRight: 10,
                padding: 20,
              }}

              onClick={()=>setNewCourseType(1)}
            >
              <div
                style={{ color: '#333', cursor: 'pointer', fontWeight: 600 }}
              >
                <StarOutlined style={{ color: '#07c160', marginRight: 5 }} />
                复用课程
              </div>
              <div
                style={{
                  color: '#666',
                  fontSize: 12,
                  margin: '10px 0 10px 20px',
                }}
              >
                复制平台或已创建的课程
              </div>
              <Radio.Group
                name="radiogroup"
                onChange={onRadioChange}
                value={value}
              >
                <Radio value={1}>平台</Radio>
                <Radio value={3}>我的</Radio>
              </Radio.Group>
              <div style={{ marginTop: 10 }}>
                <span
                  style={{ color: '#ff4b50', marginLeft: 7, marginRight: 6 }}
                >
                  *
                </span>
                <Select
                  style={{ width: 180 }}
                  placeholder="请选择使用的课程"
                  onChange={handleSelectChange}
                >
                  {courseList?.map((item, index) => {
                    return (
                      <Option key={item.id} value={item.id}>
                        <>
                        {item.name}  { value == 3 && <div style={{fontSize:12}}>{item.start_time}~{item.end_time}</div>}
                        </>
                      </Option>
                    )
                  })}
                </Select>
              </div>
              <div style={{ color: '#666', marginTop: 6, marginLeft: 20 }}>
                <Checkbox
                  style={{ marginTop: 10 }}
                  defaultChecked={true}
                  value={1}
                  onClick={onChangeMenu}
                >
                  复制大纲
                </Checkbox>
                <br />
                <Checkbox
                  style={{ marginTop: 10 }}
                  defaultChecked={true}
                  value={1}
                  onClick={onChangeLecture}
                >
                  复制课件
                </Checkbox>
                <br />
                <Checkbox
                  style={{ marginTop: 10 }}
                  defaultChecked={true}
                  value={1}
                  onClick={onChangeCase}
                >
                  复制实验
                </Checkbox>
                <br />
              </div>
            </div>
            <div
              style={{
                float: 'left',
                width: 260,
                height: 260,
                borderRadius: 3,
                border: newCourseType == 2 ? '1px solid #07c160': '1px dashed #d9d9d9',
                padding:20,
              }}

              onClick={()=>setNewCourseType(2)}
            >
              <div
                style={{
                  color: '#333',
                  //textAlign: 'center',
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
                
              >
                <FileAddOutlined style={{ color: '#07c160', marginRight: 5 }} />
                新建课程

              </div>

              <div style={{marginTop:39, marginBottom:10}}>
                <span
                  style={{ color: '#ff4b50', marginRight: 6 }}
                >
                  *
                </span> 
                课程名称
              </div>

              <div>
                <Input style={{width:200}} value={newCourseName} onChange = {(e)=>setNewCourseName(e.target.value)} placeholder='请输入课程名称' />
              </div>

            </div>
          </Modal>

          <Modal
            title={
              <div
                style={{
                  width: '100%',
                  cursor: 'move',
                }}
                onMouseOver={() => {
                  if (disabled) {
                    setDisabled(false)
                  }
                }}
                onMouseOut={() => {
                  setDisabled(true)
                }}
                onFocus={() => {}}
                onBlur={() => {}}
                // end
              >
                提示
              </div>
            }
            open={joinSuccessVisible}
            bodyStyle={{ height: '120px' }}
            destroyOnClose={true}
            closable={false}
            width={350}
            footer={[]}
            modalRender={(modal) => (
              <div className={courseStyles.miniModal}>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ textAlign: 'center', marginTop: 30 }}>
              您已加入院校{' '}
              <span style={{ color: '#07c160' }}>{collegeName}</span> ，身份为{' '}
              {role}。
            </div>
          </Modal>
        </div>

        {/** 用户尚未加入院校机构, 点击了平台课程卡片的弹窗 */}
        <Modal 
            title={<div style={{ width: '100%',cursor: 'move',}}
            onMouseOver={() => {if (disabled) {setNoCollegeDisabled(false)}}}
            onMouseOut={() => {setNoCollegeDisabled(true)}}
            onFocus={() => {}}
            onBlur={() => {}}
            >
                提示</div>
            }
            width={350}
            closable={false}
            open={isNoCollegeModalVisible}
            className={courseMainStyles.miniModal}
            footer={
                <div>
                {isLogin == true && (collegeId == 0 ||  collegeId == null || collegeId == '')  &&
                    <div>
                        <Button className={courseMainStyles.stepsBtn}
                        style={{marginRight:20,color:'#07c160',  textShadow: 'none', boxShadow:'none'}}
                        onClick={()=>{setIsNoCollegeModalVisible(false)}}>取消</Button>
                        <Button className={courseMainStyles.stepsBtn}
                        style={{marginRight:20,color:'#fff', textShadow: 'none', boxShadow:'none'}}
                        type="primary"
                        onClick={()=>{window.open("/user-center")}}>填写</Button></div>
                    }
                </div>
            }
            modalRender={modal => (<div>
                <Draggable
                disabled={noCollegeDisabled}
                bounds={noCollegeBounds}
                onStart={(event, uiData) => onNoCollegeStart(event, uiData)}
                >
                <div ref={draggleNoCollegeRef}>{modal}</div>
                </Draggable> </div>
            )}
            >
                {isLogin == true && (collegeId == 0 ||  collegeId == null || collegeId == '')  &&
                  <>
                    <div style={{textAlign:'center', padding:'0 10px'}}>
                      您还未加入院校，请点击“填写”按钮，输入院校码即可查看课程 
                    </div>
                    <div style={{textAlign:'center',padding:'20px 10px 0 10px'}}>
                      开通院校机构，请联系 <span style={{color:'#07c160'}}>136 9329 0406</span>  
                    </div>
                </>
               }
        </Modal>


      </div>
      <Feedback />
    </Layout>
  )
}

export default Course
